$(document).ready(function(){
    $('#table-returns-store').dataTable({
        "processing": true,
        "serverSide": true,
        "ajax": "/get-returns",
        "columns": [
            {data: 'id'},
            {data: 'supplier_name'},
            {data: 'reference'},
            {data: 'user_text'},
            {
                data: 'created_at',
                render: function (data, type, row) {

                    let date = new Date(data);

                    let dia = String(date.getDate()).padStart(2, '0');
                    let mes = String(date.getMonth() + 1).padStart(2, '0');
                    let anio = date.getFullYear();

                    return `${dia}-${mes}-${anio}`;
                }
            },
        ],
        "columnDefs": [
            {
                "targets": 5,
                "render": function (data, type, row, meta) {
                    console.log(row)
                return `<a href="/almacen/devoluciones/detalle/${row.uuid}"
               class="btn btn-primary btn-sm"
               data-toggle="tooltip"
               data-placement="top"
               title="Visualizar detalle">

               <i class="fas fa-list"></i>
            </a>
        `;
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    });
})
